import type { Account } from '@modules-deprecated/app/accounts/types'
import { DeductionSource } from '@modules-deprecated/app/taxrates/enums/deductionSource'
import type { TaxRate } from '@modules-deprecated/app/taxrates/types'

import { formatPaddedAccountNumber } from './formatPaddedAccountNumber'

export const getVatAccountNumberFromTaxRate = (taxRate: TaxRate | undefined, accounts: Account[]): string | null => {
  const deductionComponent =
    taxRate?.deductionComponents?.find((component) => component.source === DeductionSource.Tax) ??
    taxRate?.deductionComponents?.[0]

  if (!deductionComponent) {
    return null
  }

  const account = accounts.find(({ id }) => id === deductionComponent.accountId)

  if (account?.accountNo == null) {
    return null
  }

  return formatPaddedAccountNumber(account.accountNo)
}
